// Anfangsbuchstabe einer Beschriftung fuer das A–Z-Register. Umlaute zaehlen
// zum Grundbuchstaben, alles ohne Buchstaben steht unter '#'.
const initialOf = label => {
    const first = String(label || '')
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .charAt(0)
        .toUpperCase()

    return /[A-Z]/.test(first) ? first : '#'
}

export default initialOf
